// Подключение стилей сброса и нормализации
import 'modern-normalize/modern-normalize.css';

// Пример подключения шрифта из @fontsource:
import '@fontsource-variable/noto-sans';
import '@fontsource-variable/merriweather';

// Подключение основных стилей проекта
import "@/styles/main.scss";

// Импорт функций из модулей
import detectTouchDevice from "@/core/detectTouchDevice.js";
import processLinks from "@/core/processLinks.js";
import applyIcons from "@/core/applyIcons.js";
import applyWidgets from "@/core/applyWidgets.js";
import calcScrollbarWidth from "@/core/calcScrollbarWidth.js";
import onDomReady from "@/utils/onDomReady.js";

// Плавную прокрутку из CSS включаем только после загрузки — почему, написано
// в styles/core/_base.scss
window.addEventListener("load", function () {
    document.documentElement.classList.add("scroll-smooth");
});

// Выполнение кода после полной загрузки DOM
onDomReady(function () {
    detectTouchDevice(); // Обнаружение устройств с сенсорными экранами
    calcScrollbarWidth(); // Расчет ширины полосы прокрутки
    processLinks(); // Обработка ссылок
    applyWidgets(); // Применение виджетов
    applyIcons(); // Применение иконок
});
